import { logUtil } from 'packages/src'

function pageViewGoogleAnalyticsUtil (pathname) {
  const logPrefix = `pathname=${pathname}`

  if (!BROWSER) {
    logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} [noop] not browser`)
    return
  }

  if (!PRODUCTION) {
    logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} [noop] not production`)
    return
  }

  if (!window.gtag) {
    logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} [noop] no tag`)
    return
  }

  const pageViewData = {
    page_title: window.title,
    page_location: window.location.href,
    page_path: pathname
  }

  window.gtag('event', 'page_view', {
    ...pageViewData
  })
}

export default pageViewGoogleAnalyticsUtil
